var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"manage-price-channels-page",attrs:{"fluid":""}},[_c('PriceChannels')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }